import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "mb-3" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h4", null, "Bediener", -1)

import {ApiContactHistoryBedienerSubmitData} from '@/model/ContactHistory';
import SelectBediener from '../SelectBediener.vue';
import {doConfirm} from '@/util';
import {PropType, computed, ref, VNodeRef} from 'vue';
import moment from 'moment';

type ModelData = ApiContactHistoryBedienerSubmitData & {
  changed: boolean;
  apiGiven: boolean;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateBedienerComponent',
  props: {
  modelValue: {
    type: Array as PropType<ModelData[]>,
    default: () => [],
  },
},
  emits: {
  'update:modelValue': (newData: ModelData[]) => Array.isArray(newData),
},
  setup(__props, { expose: __expose, emit: __emit }) {

const props = __props;

const emit = __emit;

const Bedieners = computed({
  get: () => props.modelValue,
  set: (newData: ModelData[]) => emit('update:modelValue', newData),
});

const skippedBedieners = computed<Record<string, true>>(() => Object.fromEntries(Bedieners.value.map((bediener) => [bediener.Bediener, true])));

function newBediener() {
  Bedieners.value.push(emptyBediener());
}

async function deleteBediener(index: number) {
  if (
    !(await doConfirm('Diesen Bediener wirklich löschen?', 'Wirklich löschen?'))
  ) {
    return;
  }
  Bedieners.value.splice(index, 1);
}

function emptyBediener() {
  const currentTime = moment();
  const remainder = 15 - (currentTime.minute() % 15);
  return {
    Bediener: '',
    WiedervorlageDatum: moment().format('YYYY-MM-DD'),
    WiedervorlageUhrzeit: moment(currentTime).add(remainder, 'minutes').format('HH:mm'),
    Erledigt: false,
    Gelesen: false,
    changed: true,
    apiGiven: false,
  };
}

const formValid = ref(false);
const form = ref<HTMLFormElement & VNodeRef | undefined>();

__expose({
  Bedieners,
  formValid,
  form,
  skippedBedieners,
  newBediener,
  deleteBediener,
  SelectBediener,
});

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_layout = _resolveComponent("v-layout")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_v_form, {
      class: "mt-2",
      modelValue: formValid.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formValid).value = $event)),
      ref: form.value
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Bedieners.value, (bed, index) => {
          return (_openBlock(), _createBlock(_component_v_card, {
            class: "bediener-wrapper mb-3",
            color: "grey-lighten-4",
            elevation: "0",
            key: index
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_text, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_layout, { class: "bediener-header d-flex align-center mb-2" }, {
                    default: _withCtx(() => [
                      _createVNode(SelectBediener, {
                        modelValue: bed.Bediener,
                        "onUpdate:modelValue": ($event: any) => ((bed.Bediener) = $event),
                        skipped: skippedBedieners.value,
                        outlined: "",
                        class: _normalizeClass(bed.apiGiven ? undefined : 'white'),
                        onInput: ($event: any) => (bed.changed = true),
                        "show-label": false,
                        disabled: bed.apiGiven,
                        "hide-details": ""
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "skipped", "class", "onInput", "disabled"]),
                      (Bedieners.value.length > 1)
                        ? (_openBlock(), _createBlock(_component_v_btn, {
                            key: 0,
                            variant: "text",
                            color: "error",
                            icon: "",
                            style: {"z-index":"1"},
                            onClick: ($event: any) => (deleteBediener(index)),
                            class: "ml-2"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_icon, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("mdi-delete")
                                ], undefined, true),
                                _: 1
                              })
                            ], undefined, true),
                            _: 2
                          }, 1032, ["onClick"]))
                        : _createCommentVNode("", true)
                    ], undefined, true),
                    _: 2
                  }, 1024),
                  _createVNode(_component_v_layout, {
                    "d-flex": "",
                    class: "overflow-visible"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field, {
                        type: "date",
                        modelValue: bed.WiedervorlageDatum,
                        "onUpdate:modelValue": [($event: any) => ((bed.WiedervorlageDatum) = $event), ($event: any) => (bed.changed = true)],
                        variant: "outlined",
                        class: "bg-white",
                        "hide-details": ""
                      }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                      _createVNode(_component_v_text_field, {
                        type: "time",
                        modelValue: bed.WiedervorlageUhrzeit,
                        "onUpdate:modelValue": [($event: any) => ((bed.WiedervorlageUhrzeit) = $event), ($event: any) => (bed.changed = true)],
                        label: "Uhrzeit",
                        "hide-details": "",
                        variant: "outlined",
                        class: "bg-white ml-2"
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ], undefined, true),
                    _: 2
                  }, 1024),
                  _createVNode(_component_v_layout, { "d-flex": "" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_switch, {
                        modelValue: bed.Gelesen,
                        "onUpdate:modelValue": [($event: any) => ((bed.Gelesen) = $event), ($event: any) => (bed.changed = true)],
                        label: "gelesen?",
                        "hide-details": "",
                        color: "primary"
                      }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                      _createVNode(_component_v_switch, {
                        modelValue: bed.Erledigt,
                        "onUpdate:modelValue": [($event: any) => ((bed.Erledigt) = $event), ($event: any) => (bed.changed = true)],
                        label: "erledigt?",
                        "hide-details": "",
                        class: "ml-3",
                        color: "primary"
                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                    ], undefined, true),
                    _: 2
                  }, 1024)
                ], undefined, true),
                _: 2
              }, 1024)
            ], undefined, true),
            _: 2
          }, 1024))
        }), 128)),
        _createVNode(_component_v_btn, {
          class: "text-primary",
          variant: "flat",
          size: "small",
          onClick: newBediener,
          disabled: !formValid.value
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_icon, null, {
              default: _withCtx(() => [
                _createTextVNode("mdi-plus")
              ], undefined, true),
              _: 1
            }),
            _createTextVNode(" Bediener hinzufügen ")
          ], undefined, true),
          _: 1
        }, 8, ["disabled"])
      ], undefined, true),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})